import dynamic from "next/dynamic"
import { useRouter } from "next/router"
import { useContext, useEffect, useRef, useState } from "react"
import { IoIosCheckmarkCircleOutline } from "react-icons/io"
import { MdCameraAlt, MdChevronLeft, MdChevronRight, MdExpandMore, MdPlayArrow, MdVideocam } from "react-icons/md"
import Container from "../../components/base/container"
import Layout from "../../components/base/layout"
import PageLayout from "../../components/base/page-layout"
import Breadcrumb from "../../components/common/breadcrumb"
import { cues, floatingLabel, iconSvg } from "../../components/common/card-horizontal.module.scss"
import Heading from "../../components/common/heading"
import { h3 } from "../../components/common/heading.module.scss"
import LinkGrid from "../../components/common/link-grid"
import Price from "../../components/common/price"
import Modal from "../../components/common/react-modal"
import { readMore as readMoreStyle, truncate } from "../../components/common/read-more.module.scss"
import SeoLinks from "../../components/common/seo-links"
import ShowPhoneNumber from "../../components/common/show-phone-number"
import MessagePopup from "../../components/common/success-popup"
import { MapPlaceHolder } from "../../components/common/svg-icons"
import SwiperSlider from "../../components/common/swiper-slider"
import ContactDetail from "../../components/contactus/contact-detail"
import DetailsDescription from "../../components/detail/details-description"
import GalleryModal from "../../components/detail/image-gallery-modal"
import ImageGalleryPopup from "../../components/detail/image-gallery-popup"
import InquiryForm from "../../components/detail/inquiry"
import styles from "../../components/detail/property-detail.module.scss"
import UsefulLinks from "../../components/seo/useful-links"
import { sendLead } from "../../services/NetworkRequests"
import {
  INQUIRY_DESKTOP_DETAIL_SOURCE,
  INQUIRY_MOBILE_DETAIL_SOURCE,
  MAX_VIEWED_PROPERTIES,
  VIEWED_PROPERTIES_KEY,
} from "../../utils/constants"
import {
  checkUA,
  convertArea,
  convertAreaGeneral,
  fireGAEvent,
  formatText,
  getBackLink,
  getBreadcrumbs,
  getDetailLinks,
  getDetailSlugFromPropertyObject,
  getLabelAreaValues,
  getLargeSizeMapImage,
  getNewLamudiCDNLargeImage,
  getPruposeObject,
  getType,
  isAdActive,
  recordPageView,
} from "../../utils/utility"
import { GAContext } from "../_app"

const Image = dynamic(() => import("../../components/common/image"), { ssr: false })
const SimilarAds = dynamic(() => import("../../components/listing/similar-ads"), { ssr: false })
const Mapbox = dynamic(() => import("../../components/detail/detail-map"), { ssr: false })

const internalLinkingDataMobile = (data) => {
  if (data && data.length > 0) {
    const chunkSize = 3
    const linksGroup = data
      .map((e, i) => {
        return i % chunkSize === 0 ? data.slice(i, i + chunkSize) : null
      })
      .filter((e) => {
        return e
      })
    return linksGroup
  } else {
    return []
  }
}

const Details = (props) => {
  const { detail, isMobile, links: initialLinks, areaValues, resolvedUrl, breadcrumbs } = props
  const {
    listing_features,
    images = [],
    title,
    type,
    id,
    price,
    contact_person,
    mobile,
    phone,
    latitude,
    longitude,
    type_id,
    purpose_id,
    location,
    location_id,
    referer,
    host,
    videos,
    status,
  } = detail

  const purposeDetails = getPruposeObject(purpose_id)
  const purpose_title_alt1 = purposeDetails?.alternate_title
  const type_title = type?.title
  const location_breadcrumb = location?.breadcrumbs
  const [inquirySuccess, setInquiryStatus] = useState(false)
  const [links, setLinks] = useState(initialLinks)

  const [GAHash, setGAHash] = useContext(GAContext)

  const saveViewedProperty = async (id) => {
    let savedIds = await localStorage.getItem(VIEWED_PROPERTIES_KEY)

    if (!!savedIds) {
      let idsParsed = JSON.parse(savedIds)
      if (idsParsed.indexOf(id) == -1) {
        idsParsed.splice(0, 0, id)
        idsParsed = idsParsed.slice(0, MAX_VIEWED_PROPERTIES)
      } else {
        idsParsed.splice(idsParsed.indexOf(id), 1)
        idsParsed.splice(0, 0, id)
      }
      localStorage.setItem(VIEWED_PROPERTIES_KEY, JSON.stringify(idsParsed))
    } else {
      localStorage.setItem(VIEWED_PROPERTIES_KEY, JSON.stringify([id]))
    }
  }

  useEffect(async () => {
    if (typeof localStorage != "undefined") {
      saveViewedProperty(id)
    }
  }, [])

  useEffect(() => {
    recordPageView(resolvedUrl)
  }, [resolvedUrl])

  const emailFormBtnRef = useRef(null)
  const mapBoxRef = useRef(null)
  const emailFormRef = useRef(null)
  const nameInputRef = useRef(null)

  const excuteScrollToEmailForm = () => {
    emailFormRef.current.scrollIntoView({
      behavior: "smooth",
    })
    setTimeout(() => {
      nameInputRef.current.focus()
    }, 400)
  }

  let popupActiveSlideIndex
  const getGalleryActiveSlideIndex = (activeIndex) => {
    popupActiveSlideIndex = activeIndex
  }

  const [galleryInitialSlideIndex, setGalleryInitialSlideIndex] = useState(0)
  const [galleryPopupTabIndex, setGalleryPopupTabIndex] = useState(0)
  const [mapboxInteractive, setMapboxInteractive] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [readMore, setReadMore] = useState(true)
  const handleOpenModal = (tabIndex) => {
    setShowModal(true)
    setGalleryPopupTabIndex(tabIndex)
  }

  const handleCloseModal = (e) => {
    setShowModal(false)
    handleKeyboardNav(swiperEl)

    swiperEl.slideTo(popupActiveSlideIndex)
  }

  const [showCallModal, setShowCallModal] = useState(false)
  const handleOpenCallModal = () => setShowCallModal(true)
  const handleCloseCallModal = () => setShowCallModal(false)

  const sliderSettings = {
    freeMode: false,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    keyboard: true,
    pagination: {
      dynamicBullets: isMobile ? true : false,
      dynamicMainBullets: 5,
    },
    navigation: {
      nextEl: "#hero-slider-button-next",
      prevEl: "#hero-slider-button-prev",
    },
    breakpoints: {},
  }
  const [keyboardEnabled, setKeyboardEnabled] = useState(sliderSettings.keyboard)
  const [swiperEl, setSwiperEl] = useState(null)

  const handleKeyboardNav = (swiper) => {
    if (keyboardEnabled) {
      setKeyboardEnabled(false)
      swiper.keyboard.disable()
      return
    }
    setKeyboardEnabled(true)
    swiper.keyboard.enable()
  }

  const getTitle = () => {
    return `${title.en} - ${location_breadcrumb?.slice(-1)[0].title.en} - Lamudi.pk`
  }

  const updateInitialSlideIndex = (swiper) => {
    setGalleryInitialSlideIndex(swiper.activeIndex)
  }

  const parseSideLinks = () => {
    let linksParsed = []

    const { sideLinks } = links
    if (sideLinks) {
      const { otherOptions, relatedAreaLinks, relatedLinks } = sideLinks

      if (otherOptions && otherOptions.length > 0) {
        linksParsed.push({
          heading: `Other Options in ${location_breadcrumb?.[location_breadcrumb?.length - 1].title.en}`,
          links: otherOptions.map(({ ads_count, slug, title }) => ({
            title: title,
            count: ads_count,
            link: `/${slug.indexOf("/") == 0 ? slug.slice(1) : slug}`,
          })),
        })
      }
      if (relatedAreaLinks && relatedAreaLinks.length > 0) {
        linksParsed.push({
          heading: `Related ${areaValues.area} ${areaValues.unit} Options in ${
            location_breadcrumb?.[location_breadcrumb.length - 1].title.en
          }`,
          links: relatedAreaLinks.map(({ ads_count, slug, title }) => ({
            title: title,
            count: ads_count,
            link: `/${slug.indexOf("/") == 0 ? slug.slice(1) : slug}`,
          })),
        })
      }

      if (relatedLinks && relatedLinks.length > 0) {
        linksParsed.push({
          heading: `Related Options in ${location_breadcrumb[location_breadcrumb.length - 1].title.en}`,
          links: relatedLinks.map(({ ads_count, slug, title }) => ({
            title: title,
            count: ads_count,
            link: `/${slug.indexOf("/") == 0 ? slug.slice(1) : slug}`,
          })),
        })
      }
    }
    return linksParsed
  }

  const parseBottomLinks = () => {
    let linksParsed = []

    const { bottomLinks } = links

    if (bottomLinks) {
      const { otherOptions, longtail, relatedAreaLinks } = bottomLinks

      if (relatedAreaLinks && relatedAreaLinks.length > 0 && type?.title?.en) {
        linksParsed.push({
          heading: `Browse ${type?.title?.en} for ${purpose_id == 1 ? "Sale" : "Rent"} by Area Size`,
          links: relatedAreaLinks.map(({ ads_count, slug, title }) => ({
            title: title,
            count: ads_count,
            href: `/${slug.indexOf("/") == 0 ? slug.slice(1) : slug}`,
          })),
        })
      }
      if (otherOptions && otherOptions.length > 0) {
        linksParsed.push({
          heading: `Other Properties for ${purpose_id == 1 ? "Sale" : "Rent"} in ${
            location_breadcrumb[location_breadcrumb.length - 1].title.en
          }`,
          links: otherOptions.map(({ ads_count, slug, title }) => ({
            title: title,
            count: ads_count,
            href: `/${slug.indexOf("/") == 0 ? slug.slice(1) : slug}`,
          })),
        })
      }
      if (longtail && longtail.length > 0) {
        linksParsed.push({
          heading: `Browse by Popular Keywords in ${location_breadcrumb[location_breadcrumb?.length - 1]?.title?.en}`,
          links: longtail.map(({ ads_count, slug, title }) => ({
            title: title,
            count: ads_count,
            href: `/${slug.indexOf("/") == 0 ? slug.slice(1) : slug}`,
          })),
        })
      }
    }
    return linksParsed
  }
  let parsedBottomLinks = parseBottomLinks()

  const amenitiesShowMore = listing_features?.length > 4

  const router = useRouter()

  let backToSearchLink = getBackLink({
    referer,
    location_breadcrumb,
    host,
    purpose_id,
    type_id,
    currentUrl: router.asPath.slice(0, -1),
    prevLink: breadcrumbs.slice(-1)[0],
  })

  let imagesList = images
  let province_id = location_breadcrumb?.[1]?.id
  let areaInMeters = convertAreaGeneral(detail?.area, "Square Feet", "Square Meter")
  let areaLabel = convertArea(areaInMeters, province_id)
  const metaDescription = `This ${getType(type_id)?.name} is a ${areaLabel}, ${
    !!detail?.beds ? `${detail?.beds} Beds` : ""
  } ${!!detail?.baths ? `, ${detail?.baths} Baths` : ""} ${
    purpose_id == 1 ? "for Sale" : "for Rent"
  } listed on Lamudi.pk for ${detail?.price_formated} in ${detail?.location?.breadcrumbs?.[2]?.title?.en}, ${
    detail?.location?.breadcrumbs?.slice(-1)[0]?.title?.en
  } - ${detail?.id}
  `

  const showImageSlider = (imagesList) => {
    if (!imagesList || (imagesList && imagesList.length == 0)) {
      return false
    }
    if (imagesList?.length > 0) {
      return imagesList?.[0]?.uuid
    }
    return false
  }

  return (
    <>
      <style jsx>{`
        .lbl {
          display: inline-block;
          width: 50%;
        }
      `}</style>

      <PageLayout
        pageTitle=""
        socialUrl={`${process.env.BASE_URL}${router.asPath.slice(0, -1)}`}
        headTitle={getTitle()}
        bannerless
        description={metaDescription}
        backButton={
          isMobile && (
            <button className={styles.backButton} onClick={() => router.push(backToSearchLink)}>
              <MdChevronLeft size="24px" />
            </button>
          )
        }
        containerClass={isMobile && styles.navSpaceBetween}
        navBarClassName={styles.pageLayoutBorder}
      >
        {!isMobile && (
          <Breadcrumb
            backToSearchLink={backToSearchLink}
            breadcrumbs={breadcrumbs}
            className="u-mb32"
            currentLinkText={id}
          />
        )}
        <Container>
          <Heading className={`${styles.mainHeading} ${h3}`} variant="h1">{`${title?.en} ${formatText(
            breadcrumbs?.slice(-1)[0]?.title
          )}`}</Heading>

          <Layout className="u-mb24">
            <div>
              <div className={styles.coverSlider}>
                {showImageSlider(imagesList) && (
                  <div id="hero-slider-button-prev" className="swiper-button-prev swiper-navigation-button">
                    <MdChevronLeft className="sliderIcon" />
                  </div>
                )}
                {showImageSlider(imagesList) && (
                  <div id="hero-slider-button-next" className="swiper-button-next swiper-navigation-button">
                    <MdChevronRight className="sliderIcon" />
                  </div>
                )}

                {showImageSlider(imagesList) ? (
                  <SwiperSlider
                    className="sliderImageRatio"
                    sliderOptions={sliderSettings}
                    onClick={(e) => handleKeyboardNav(e)}
                    onSwiper={(e) => setSwiperEl(e)}
                    onSlideChange={(swiper) => updateInitialSlideIndex(swiper)}
                  >
                    {imagesList?.map((slide, i) => {
                      const uuid = slide?.uuid ? slide?.uuid : ""
                      const url = slide?.large ? slide?.large : ""
                      let imageURL = getNewLamudiCDNLargeImage(uuid, url)
                      return (
                        <Image
                          onClick={() => handleOpenModal(0)}
                          src={imageURL}
                          key={i}
                          alt={`${title?.en} - ${breadcrumbs?.slice(-1)[0]?.title}`}
                          title={`${title?.en} - ${breadcrumbs?.slice(-1)[0]?.title}`}
                        />
                      )
                    })}
                  </SwiperSlider>
                ) : (
                  <Image src={getLargeSizeMapImage(latitude, longitude)} />
                )}
                <div className={`flex u-spbwx4 ${cues}`}>
                  {showImageSlider(imagesList) ? (
                    <button onClick={() => handleOpenModal(0)} className={`${floatingLabel}`}>
                      <MdCameraAlt className={iconSvg} /> <span>{imagesList.length} Images</span>
                    </button>
                  ) : null}
                  {videos?.length > 0 ? (
                    <button onClick={() => handleOpenModal(1)} className={`${floatingLabel}`}>
                      <MdVideocam className={iconSvg} />{" "}
                      <span>
                        {videos?.length} {videos?.length > 1 ? "Videos" : "video"}
                      </span>
                    </button>
                  ) : null}
                </div>
                {videos?.length > 0 && (
                  <button
                    onClick={() => handleOpenModal(1)}
                    className={`${styles.playIcon} flex flexYcenter flexXcenter`}
                  >
                    <MdPlayArrow className={styles.icon} />
                  </button>
                )}
              </div>
              <DetailsDescription
                areaLabel={areaLabel}
                headingClassName={styles.sectionHeading}
                setMapboxInteractive={setMapboxInteractive}
                stickyPosition={isMobile ? "bottom" : "top"}
                emailFormRef={emailFormRef}
                detail={detail}
                mapBox={mapBoxRef}
                openModal={handleOpenCallModal}
                excuteScrollToEmailForm={excuteScrollToEmailForm}
              />
              {listing_features && listing_features.length > 0 && (
                <div id="amenitiesSection" className="u-mb40">
                  <Heading className={`${styles.sectionHeading} u-mb16`} variant="h3">
                    Amenities
                  </Heading>
                  <div className={readMore && amenitiesShowMore ? truncate : ""}>
                    {listing_features?.map((item, index) => {
                      return (
                        <ul className={`${styles.amenitiesList} u-spbwy8 u-mb16`} key={"feature" + item.group_id}>
                          <Heading className="u-mb16" variant="h4">
                            {item?.title?.en}
                          </Heading>
                          {item?.features?.map((subItem, ind) => {
                            return (
                              <li key={ind}>
                                {subItem?.title?.en ? <span className="lbl">{subItem?.title?.en}</span> : null}
                                {subItem?.value?.en ? <span className="value">{subItem?.value?.en}</span> : null}
                              </li>
                            )
                          })}
                        </ul>
                      )
                    })}
                  </div>
                  {amenitiesShowMore ? (
                    <button
                      onClick={() => {
                        document.getElementById("amenitiesSection").scrollIntoView({ behavior: "smooth" })
                        setReadMore(!readMore)
                      }}
                      className={readMoreStyle}
                    >
                      {readMore ? "Show More" : "Show less"}
                      <MdExpandMore />
                    </button>
                  ) : null}
                </div>
              )}
              <div className="u-mb32" ref={mapBoxRef}>
                <Heading className={styles.sectionHeading} variant="h3">
                  Map
                </Heading>
                <Heading variant="h4">{location?.long_title?.en}</Heading>
                <div
                  className={`${styles.mapboxContainer} ${!mapboxInteractive ? styles.mapUninteractive : ""}`.trim()}
                  onClick={() => {
                    setMapboxInteractive(true)
                  }}
                >
                  {mapboxInteractive ? (
                    <div className={styles.mapBox}>
                      <Mapbox title={location?.long_title?.en} longitude={longitude} latitude={latitude} />
                    </div>
                  ) : (
                    <>
                      <MapPlaceHolder className={styles.mapPlaceHolder} />
                      <div className={`${styles.mapPlaceHolderText} flex flexYcenter flexXcenter`}>
                        Click to Load Map
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div>
              <div
                className="panel u-mb16"
                style={
                  !isAdActive(detail?.status)
                    ? {
                        borderColor: "red",
                      }
                    : {}
                }
              >
                {!isAdActive(detail?.status) && (
                  <p
                    style={{
                      fontWeight: 600,
                      textAlign: "center",
                    }}
                  >
                    This property is no longer available
                  </p>
                )}
                {isAdActive(detail.status) && (
                  <Price className={`${styles.price} u-mb16 flexXcenter`} variant="h4" price={price} />
                )}
                {isAdActive(detail.status) && (
                  <ShowPhoneNumber
                    onClick={() => {
                      sendLead(id, "property", "phone")
                      let GAEvent = {
                        label: `${purpose_id == 1 ? "buy" : "rent"} - property_detail - ${
                          isMobile ? "web-mobile" : "web"
                        }`,
                      }
                      const hash = `phone_view-${id}`

                      fireGAEvent(
                        { ...GAEvent, category: "Lead", action: "phone_view" },
                        { ...GAEvent, category: "Unique Leads", action: "phone_view_unique" },
                        GAHash,
                        hash,
                        setGAHash
                      )

                      handleOpenCallModal()
                    }}
                    block
                  />
                )}
              </div>
              {isAdActive(detail.status) && (
                <div className="panel u-mb16" ref={emailFormRef}>
                  <Heading className={`${styles.sectionHeading} ${isMobile ? "u-mb16" : "u-mb24"}`} variant="h4">
                    Ask about the property
                  </Heading>
                  <InquiryForm
                    GACallbackEvent={() => {
                      let GAEvent = {
                        label: `${purpose_id == 1 ? "buy" : "rent"} - property_detail - ${
                          isMobile ? "web-mobile" : "web"
                        }`,
                      }

                      const hash = `email_lead-${id}`

                      fireGAEvent(
                        { ...GAEvent, category: "Lead", action: "email_lead" },
                        { ...GAEvent, category: "Unique Leads", action: "email_lead_unique" },
                        GAHash,
                        hash,
                        setGAHash
                      )
                    }}
                    ea_alert_source={isMobile ? INQUIRY_MOBILE_DETAIL_SOURCE : INQUIRY_DESKTOP_DETAIL_SOURCE}
                    onSuccess={() => {
                      setInquiryStatus(true)
                    }}
                    propertyId={id}
                    emailFormBtnRef={emailFormBtnRef}
                    nameInputRef={nameInputRef}
                  />
                  <Modal showModal={inquirySuccess} onClickClose={() => setInquiryStatus(false)}>
                    <MessagePopup
                      heading="Success"
                      description={"Your message has been sent successfully."}
                      icon={<IoIosCheckmarkCircleOutline />}
                    />
                  </Modal>
                </div>
              )}
              {links.sideLinks && links.sideLinks ? (
                <div className="panel">
                  <UsefulLinks
                    headingClassName={styles.sectionHeading}
                    mainHeading="Useful Links"
                    linkData={parseSideLinks()}
                  />
                </div>
              ) : null}
            </div>
          </Layout>

          <SimilarAds
            property_id={id}
            type_id={type_id}
            purpose_id={purpose_id}
            location_id={location_id}
            type_title={type_title}
            purpose_title_alt1={purpose_title_alt1}
            location_text={location?.long_title}
            onSuccess={() => {
              setInquiryStatus(true)
            }}
          />
          <div className="u-mb54">
            {parsedBottomLinks && parsedBottomLinks.length > 0
              ? parsedBottomLinks.map(({ heading, links }) =>
                  isMobile ? (
                    <div className="u-mb24">
                      <Heading className="u-mb16" variant="h3">
                        {heading}
                      </Heading>
                      {internalLinkingDataMobile(links).map((e, i) => {
                        return (
                          <SeoLinks
                            className="u-mb8"
                            title="Other Properties for Rent in DHA Phase 6"
                            headingVariant="h3"
                            data={e}
                          />
                        )
                      })}
                    </div>
                  ) : (
                    <LinkGrid title={heading} headingVariant="h4" gridColumn="4" linkRowGap="8px" data={links} />
                  )
                )
              : null}
          </div>
        </Container>
      </PageLayout>

      <GalleryModal className={styles.imageGalleryPopup} showModal={showModal} onClickClose={handleCloseModal}>
        <ImageGalleryPopup
          areaLabel={areaLabel}
          details={detail}
          onClickClose={handleCloseModal}
          openCallModal={handleOpenCallModal}
          isMobile={isMobile}
          galleryPopupTabIndex={galleryPopupTabIndex}
          galleryInitialSlideIndex={galleryInitialSlideIndex}
          getGalleryActiveSlideIndex={getGalleryActiveSlideIndex}
        ></ImageGalleryPopup>
      </GalleryModal>

      <Modal showModal={showCallModal} onClickClose={handleCloseCallModal}>
        <ContactDetail
          purpose={purpose_id == 1 ? "for-sale" : "for-rent"}
          property_id={id}
          mobile={mobile}
          contactPerson={contact_person}
          phone={phone}
          onClickClose={handleCloseCallModal}
        ></ContactDetail>
      </Modal>
    </>
  )
}

export default Details

export async function getServerSideProps(ctx) {
  let url = ctx.resolvedUrl
  let pathname = url.split("?")[0]
  let splitted = url.split("-")
  splitted.reverse()
  let propertyId = splitted[0].split(".html")[0]
  const { getFromLegion } = await import("../../services/legionServerClient")
  let resp = await getFromLegion(`external/listings?q[id_eq]=${propertyId}`)
  if (resp?.data?.listings && resp?.data?.listings?.length > 0) {
    let property = resp?.data?.listings[0]

    let actualSlug = getDetailSlugFromPropertyObject(property)
    let isMobile = checkUA(ctx.req.headers["user-agent"])
    if (`${actualSlug}/` == pathname) {
      const detail = {
        ...resp?.data?.listings[0],
        referer: ctx.req.headers.referer || null,
        host: ctx.req.headers.host,
      }
      const { location_id, purpose_id, type_id, type, location, area } = detail

      let areaValues = getLabelAreaValues(area, location?.breadcrumbs?.[1].id)

      let combinedResp = await Promise.all([
        getDetailLinks({
          location_id,
          purpose_id,
          type_id,
          type_parent_id: type?.parent_id,
          province_id: location?.breadcrumbs?.[1].id,
          level: location?.breadcrumbs?.length,
          area_unit: areaValues.unit,
          label_area_unit: areaValues.area,
          locs: location?.breadcrumbs?.slice(2).map((item) => item.id),
        }),
        getBreadcrumbs(
          location?.breadcrumbs?.map((item) => item.id),
          purpose_id,
          type_id
        ),
      ])

      let links = combinedResp[0]
      let breadcrumbs = combinedResp[1]
      breadcrumbs = breadcrumbs.map((item) => ({ slug: item.slug, title: item.locality_name }))
      return {
        props: {
          detail,
          isMobile,
          links,
          areaValues,
          resolvedUrl: ctx.resolvedUrl,
          breadcrumbs,
        },
      }
    } else {
      ctx.res.writeHead(301, {
        Location: actualSlug,
      })
      ctx.res.end()
    }
  } else {
    return {
      props: {
        error: true,
        resolvedUrl: ctx.resolvedUrl,
      },
      notFound: true,
    }
  }
}
